<template>
  <el-dialog
      title="导入风险事故类型记录"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
  >
    <div class="import-dialog">
      <!-- 上传文件 -->
      <div class="step-content">
        <div class="upload-section">
          <el-upload
              class="upload-demo"
              drag
              action=""
              :auto-upload="false"
              :on-change="handleFileChange"
              :file-list="fileList"
              accept=".xlsx,.xls"
              :show-file-list="true"
              :before-upload="beforeUpload"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">
              <div>只能上传xlsx/xls文件，且不超过10MB</div>
              <div style="margin-top: 10px; color: #f56c6c;">
                请使用标准格式的Excel文件
              </div>
            </div>
          </el-upload>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button
            type="primary"
            @click="doImport"
            :disabled="!uploadFile"
            :loading="importing"
        >
          开始导入
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import Risk_typeApi from '@/api/risk_type.js';
export default {
  data() {
    return {
      dialogVisible: false,
      importing: false,
      uploadFile: null,
      fileList: []
    };
  },
  props: ["open_import"],
  watch: {
    open_import(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        this.resetDialog();
      }
    }
  },
  created() {
    this.dialogVisible = this.open_import;
  },
  methods: {
    resetDialog() {
      this.uploadFile = null;
      this.fileList = [];
      this.importing = false;
    },

    closeDialog() {
      this.$emit("close", { openDialog: false, "type": "import" });
    },

    // 文件上传前的验证
    beforeUpload(file) {
      const isExcel = file.type === 'application/vnd.ms-excel' ||
          file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isExcel) {
        this.$message.error('只能上传Excel文件!');
        return false;
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!');
        return false;
      }
      return true;
    },

    // 处理文件选择
    handleFileChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]; // 只保留最后一个文件
      }

      this.uploadFile = file;
    },

    // 执行导入
    async doImport() {
      if (!this.uploadFile) {
        this.$message.error('请先选择文件');
        return;
      }

      this.importing = true;

      try {
        const formData = new FormData();
        formData.append('file', this.uploadFile.raw);

        // 调用导入API
        const result = await Risk_typeApi.importData(formData, true);

        if (result.code === 1) {
          this.$message.success(result.msg || '导入成功');
          this.closeDialog();
          // 触发父组件刷新数据
          this.$emit("close", {
            openDialog: false,
            "type": "import",
            refresh: true
          });
        } else {
          this.$message.error(result.msg || '导入失败');
        }

      } catch (error) {
        console.error('导入错误:', error);
        this.$message.error('导入失败：' + (error.message || '网络错误'));
      } finally {
        this.importing = false;
      }
    }
  }
};
</script>

<style scoped>
.import-dialog {
  padding: 10px;
}

.step-content {
  min-height: 200px;
  padding: 20px 0;
}

.upload-section {
  text-align: center;
}

.dialog-footer {
  text-align: right;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

/* 上传组件样式调整 */
.upload-demo {
  margin: 0 auto;
  max-width: 400px;
}

.el-upload-dragger {
  width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/risk_type/index/part/import.vue